import {
  Container,
  Row,
  Col,
  FreePricingVeriticalCard,
  SubscriptionOfferVerticalCard,
  TeamSubscriptionVerticalCard,
  UnitPricingVerticalCard
} from 'UI/'
import Text from './text.json'
import { createUseStyles, useTheme } from 'react-jss'
import style from './style'
import { useEffect, useState } from 'react'
import { CartPath, CatalogPath, SubscriptionCheckoutPath } from 'navigation/Routes'
import { defaultCurrency } from 'store/currency'
import { billingCycleId, ExternalAlphormPages, ProfileTypes, threeTimesPaymentFeature } from 'constants/'
import { signin } from 'identity/userManager'
import { decorateUrl } from 'components/common/UTMscript'

const useStyle = createUseStyles(style)

export default ({
  goToUrl,
  selectInitialChoice,
  isDefault,
  initialCurrency,
  alternativeCurrency,
  switchCurrency,
  annualPrice,
  monthlyPrice,
  isConnected,
  addSubscriptionToCart,
  activeSubscription,
  goHome,
  annualPricePromo,
  monthlyPricePromo,
  profileType,
  FetchUserSubscription,
  FetchUser,
  signup,
  isElligableForTrial,
  setTrialState,
  startTrialOnboarding,
  setCheckoutOnboarding,
  isPricingPage,
  PricePromo,
  AlternativePricePromo,
  Price,
  AlternativePrice,
  Id,
  Title,
  Image,
  MobileImageUrl,
  Rating,
  ReviewersCount,
  Duration,
  ViewersCount,
  Slug,
  addToCart,
  isLearningPath,
  learningPathPrice,
  learningPathAlternativePrice,
  learningPathCourses,
  fetchLearningPathAllCoursesAction,
  learningPathId,
  addLearningPathToCart,
  shopPhone,
  showUnitPricing,
  margin,
  isAlgeria
}) => {
  const theme = useTheme()
  const { card1, card2, card3, cardsContainer } = useStyle({ margin })
  const [subType, setSubType] = useState(billingCycleId.annual)
  const handleStartSubscriptionClick = () => {
    if (isConnected) {
      selectInitialChoice(subType)
      addSubscriptionToCart()
      if (threeTimesPaymentFeature && initialCurrency === defaultCurrency) {
        goHome()
        setTrialState(false)
        startTrialOnboarding()
        setCheckoutOnboarding(true)
      } else {
        goToUrl(SubscriptionCheckoutPath)
      }
    } else {
      signin()
    }
  }
  useEffect(() => {
    if (isConnected) {
      FetchUserSubscription()
      FetchUser()
    }
  }, [isConnected])
  useEffect(() => {
    isLearningPath && fetchLearningPathAllCoursesAction(learningPathId)
  }, [learningPathId, isLearningPath])
  useEffect(() => { (activeSubscription && profileType === ProfileTypes.PremiumSubscriber) && goHome() }, [activeSubscription, profileType])
  const annualPricePerMonth = annualPrice ? Number(annualPrice / 12).toFixed(2) : null
  const annualPricePromoPerMonth = annualPricePromo ? Number(annualPricePromo / 12).toFixed(2) : null
  const StartTrialSubscription = () => {
    setTrialState(true)
    if (isConnected) {
      goHome()
      startTrialOnboarding()
      setCheckoutOnboarding(false)
    } else {
      signup()
    }
  }
  const handleFreeCardClick = () => {
    if (isConnected && isPricingPage) {
      goToUrl(CatalogPath)
    } else if (isConnected && isLearningPath) {
      addLearningPathToCart(learningPathCourses)
      goToUrl(CartPath)
    } else {
      signin()
    }
  }

  const handleStartUinitClick = () => {
    if (isPricingPage) {
      goToUrl(CatalogPath)
    } else if (isLearningPath) {
      addLearningPathToCart(learningPathCourses)
      goToUrl(CartPath)
    } else {
      addToCart({
        Id,
        Title,
        Image,
        MobileImageUrl,
        Price,
        Rating,
        ReviewersCount,
        Duration,
        ViewersCount,
        Slug,
        AlternativePrice,
        PromotionPrice: PricePromo,
        AlternativePricePromo
      })
    }
  }

  let unitSubscriptionCardPrice = ''
  if (!isPricingPage) {
    if (initialCurrency === defaultCurrency) {
      unitSubscriptionCardPrice = isLearningPath ? learningPathPrice : Price
    } else {
      unitSubscriptionCardPrice = isLearningPath ? learningPathAlternativePrice : AlternativePrice
    }
  }
  const isPromoVisible = !!PricePromo && !isPricingPage && !isLearningPath
  const coursePricePromo = initialCurrency === defaultCurrency ? PricePromo : AlternativePricePromo

  return (
    <Container>
      <Row className={cardsContainer}>
        {
          !isConnected && isPricingPage
            ? (
              <Col className={card3} grid={4} mgrid={12} sgrid={12} pos='end'>
                <FreePricingVeriticalCard
                  {...Text.FreePricingVeriticalCard}
                  freePrice={0}
                  price={monthlyPrice}
                  periodText={Text.billingCyclesPeriodsMensuel}
                  currency={!isPricingPage ? initialCurrency : initialCurrency}
                  handleCtaClick={handleFreeCardClick}
                  titleAs='p'
                />
              </Col>
              )
            : null
        }
        {
          showUnitPricing
            ? (
              <Col className={card3} grid={4} mgrid={12} sgrid={12} pos='end'>
                <UnitPricingVerticalCard
                  {...Text.UnitSubscriptionVerticalCard}
                  promo={isPromoVisible}
                  pricePromo={coursePricePromo}
                  price={unitSubscriptionCardPrice}
                  startSubscriptionLabel={isPricingPage ? Text.UnitSubscriptionVerticalCard.showInCatalogLabel : Text.UnitSubscriptionVerticalCard.startSubscriptionLabel}
                  hideSwitchCurrency={isDefault || isPricingPage}
                  currency={!isPricingPage ? initialCurrency : ''}
                  currency1={defaultCurrency}
                  currency2={alternativeCurrency}
                  selectedCurrency={initialCurrency}
                  handleChangeCurrency={switchCurrency}
                  promoText='promo'
                  threeTimePayment={threeTimesPaymentFeature}
                  threeTimePaymentDescription={Text.unitThreeTimesPaiment}
                  handleStartSubscriptionClick={handleStartUinitClick}
                  titleAs='p'
                  shadowColor={isLearningPath ? theme.extra.pink : theme.secondary[0]}
                  isLearningPath={isLearningPath}
                />
              </Col>
              )
            : null
        }
        <Col start={!((!isConnected && isPricingPage) || showUnitPricing) ? 3 : 'auto'} pos='end' className={card1} grid={4} mgrid={12} sgrid={12}>
          <SubscriptionOfferVerticalCard
            {...Text.SubscriptionOfferVerticalCard}
            engagement={isElligableForTrial ? `${Text.SubscriptionOfferVerticalCard.engagement1} ${annualPricePerMonth} ${Text.SubscriptionOfferVerticalCard.engagement2}` : Text.SubscriptionOfferVerticalCard.engagementDefault}
            freeTrial={isElligableForTrial && initialCurrency === defaultCurrency}
            threeTimePayment={threeTimesPaymentFeature && initialCurrency === defaultCurrency}
            threeTimePaymentDescription={Text.subscriptionThreeTimesPaiment}
            hideSwitchCurrency={isDefault}
            price={subType === billingCycleId.annual ? annualPricePerMonth : monthlyPrice}
            type={subType}
            monthly={Text.billingCyclesPeriodsMensuel}
            currency={initialCurrency}
            currency1={defaultCurrency}
            currency2={alternativeCurrency}
            selectedCurrency={initialCurrency}
            handleChangeCurrency={switchCurrency}
            handleStartSubscriptionClick={handleStartSubscriptionClick}
            handleTrialSubscriptionClick={StartTrialSubscription}
            promo={subType === billingCycleId.annual ? !!annualPricePromo : !!monthlyPricePromo}
            pricePromo={subType === billingCycleId.annual ? annualPricePromoPerMonth : monthlyPricePromo}
            promoText={Text.promoText}
            yearlySwitchLabel={Text.billingCyclesAnnuel}
            monthlySwitchLabel={Text.billingCyclesMensuel}
            handleChangeSubscriptionType={() => setSubType(subType === billingCycleId.annual ? billingCycleId.monthly : billingCycleId.annual)}
            billedYearlyText1={`${Text.billedYearly} (${annualPricePromo || annualPrice} ${initialCurrency})`}
          />
        </Col>
        <Col className={card2} grid={4} mgrid={12} sgrid={12} pos='end'>
          <TeamSubscriptionVerticalCard
            {...Text.teamSubscriptionVerticalCard}
            handleButtonClick={() => window.open(decorateUrl(isAlgeria ? ExternalAlphormPages.AlgerianBusinessOffer : ExternalAlphormPages.BusinessOffer), '_blank')}
            phoneNumber={shopPhone}
            titleAs='p'
          />
        </Col>
      </Row>
    </Container>
  )
}
